export default "__VITE_ASSET__F_F9f0SB__"